import { ParsedUrlQuery } from 'querystring';

const DEFAULT_SOURCE = 'website';
const GOOGLE_ADS_SOURCE = 'google-ads';
const FACEBOOK_ADS_SOURCE = 'facebook';

export default function getTrafficSource(query: ParsedUrlQuery): string {
  if (query.gclid) {
    return GOOGLE_ADS_SOURCE;
  }
  if (query.fbclid) {
    return FACEBOOK_ADS_SOURCE;
  }

  return (query.utm_source as string) || DEFAULT_SOURCE;
}
